import React, { useMemo } from 'react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import DoneIcon from '@mui/icons-material/Done';
import RotateRightIcon from '@mui/icons-material/RotateRight';

import clsx from 'clsx';

import { TrainingSetItemStatus } from '../../../shared/constants';
import { useStyles } from './TrainingSetItemStatusIcon.styles';

interface TrainingSetItemStatusProps {
  status: TrainingSetItemStatus;
}

export default function TrainingSetItemStatusIcon(
  props: TrainingSetItemStatusProps,
) {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const classesMap = useMemo(
    () => ({
      [TrainingSetItemStatus.notStarted]: classes.notStarted,
      [TrainingSetItemStatus.doLate]: classes.doLate,
      [TrainingSetItemStatus.skipped]: classes.skipped,
      [TrainingSetItemStatus.finished]: classes.finished,
    }),
    [],
  );

  const StatusIcons = useMemo(
    () => ({
      [TrainingSetItemStatus.notStarted]: <DoneIcon />,
      [TrainingSetItemStatus.doLate]: <RotateRightIcon />,
      [TrainingSetItemStatus.skipped]: <DoDisturbIcon />,
      [TrainingSetItemStatus.finished]: <DoneIcon />,
    }),
    [],
  );

  return (
    <Box className={clsx(classes.statusIcon, classesMap[props.status])}>
      {StatusIcons[props.status]}
    </Box>
  );
}
